import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/cashwheel/bg_light.png'
import _imports_1 from '@/assets/cashwheel/wheel1.png'
import _imports_2 from '@/assets/cashwheel/spinBg.png'
import _imports_3 from '@/assets/cashwheel/prize.png'
import _imports_4 from '@/assets/cashwheel/light1.png'
import _imports_5 from '@/assets/cashwheel/light2.png'
import _imports_6 from '@/assets/cashwheel/pointer.png'
import _imports_7 from '@/assets/cashwheel/draw.png'
import _imports_8 from '@/assets/cashwheel/num_1.png'
import _imports_9 from '@/assets/cashwheel/num_0.png'


const _hoisted_1 = { class: "mainDraw" }
const _hoisted_2 = { class: "mainDraw_bg" }
const _hoisted_3 = { class: "prize" }
const _hoisted_4 = { class: "sector-wrapper" }
const _hoisted_5 = {
  width: "200",
  height: "200",
  viewBox: "0 0 215 215"
}
const _hoisted_6 = { class: "lights" }
const _hoisted_7 = {
  key: 0,
  src: _imports_4,
  alt: ""
}
const _hoisted_8 = {
  key: 1,
  src: _imports_5,
  alt: ""
}
const _hoisted_9 = { class: "draw_count" }
const _hoisted_10 = {
  key: 1,
  src: _imports_9,
  alt: ""
}

import { ref, onMounted, onUnmounted } from 'vue'

const TOTAL_PRIZES = 8


export default /*@__PURE__*/_defineComponent({
  __name: 'cashWheel',
  emits: ['showWinPopup'],
  setup(__props, { emit: __emit }) {

const showLight1 = ref(true)
let lightInterval: number

const prizeRef = ref<HTMLElement | null>(null)
const spinBgRef = ref<HTMLElement | null>(null)
const spinCount = ref(1);
let isSpinning = false
const emits = __emit
const clickSpinDraw = async () => {
    if (isSpinning) return
    isSpinning = true
    spinCount.value = 0;
    const selectedIndex = Math.floor(Math.random() * TOTAL_PRIZES)
    console.log('selectedIndex', selectedIndex);

    const degreesPerPrize = 360 / TOTAL_PRIZES
    const fullRotations = 5
    const finalAngle = (fullRotations * 360) - (degreesPerPrize * selectedIndex)

    const duration = 4000

    prizeRef.value?.style.setProperty('transition', `transform ${duration}ms ease-out`)
    spinBgRef.value?.style.setProperty('transition', `transform ${duration}ms ease-out`)

    prizeRef.value?.style.setProperty('transform', `rotate(${finalAngle}deg)`)
    spinBgRef.value?.style.setProperty('transform', `rotate(${finalAngle}deg)`)

    setTimeout(() => {
        isSpinning = false
        console.log(`Landed on prize index: ${selectedIndex}`)
        showSectorFlash()
    }, duration + 100)
}
const sectorPath = ref<SVGPathElement | null>(null)

const showSectorFlash = () => {
    const el = sectorPath.value
    if (!el) return

    el.classList.remove('hidden')
    el.classList.add('flashing')

    setTimeout(() => {
        el.classList.remove('flashing')
        el.classList.add('hidden')
        emits('showWinPopup')
    }, 3000)
}
onMounted(() => {
    lightInterval = window.setInterval(() => {
        showLight1.value = !showLight1.value
    }, 500)
})

onUnmounted(() => {
    clearInterval(lightInterval)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "wheel_bg" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "rotating-bg"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_1,
        alt: ""
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          ref_key: "spinBgRef",
          ref: spinBgRef,
          src: _imports_2,
          alt: "",
          class: "spin-img"
        }, null, 512),
        _createElementVNode("img", {
          ref_key: "prizeRef",
          ref: prizeRef,
          src: _imports_3,
          alt: "",
          class: "spin-img"
        }, null, 512),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock("svg", _hoisted_5, [
            _createElementVNode("path", {
              ref_key: "sectorPath",
              ref: sectorPath,
              d: "M100,100 L60,17 A100,100 0 0,1 135.71,15.29 Z",
              fill: "transparent",
              stroke: "white",
              class: "sector-path hidden",
              "stroke-width": "6"
            }, null, 512)
          ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (showLight1.value)
          ? (_openBlock(), _createElementBlock("img", _hoisted_7))
          : (_openBlock(), _createElementBlock("img", _hoisted_8))
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "pointer" }, [
        _createElementVNode("img", {
          src: _imports_6,
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", {
        class: "draw",
        onClick: clickSpinDraw
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          src: _imports_7,
          alt: ""
        }, null, -1)
      ])),
      _createElementVNode("div", _hoisted_9, [
        (spinCount.value == 1)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _imports_8,
              alt: "",
              onClick: clickSpinDraw
            }))
          : _createCommentVNode("", true),
        (spinCount.value == 0)
          ? (_openBlock(), _createElementBlock("img", _hoisted_10))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})